import React, { useState, useEffect } from "react";

import "./MindMapsDemo.css";

const BRANCH_REVEAL_INTERVAL_MS = 500;
const TOTAL_BRANCHES = 5;
const HIGHLIGHT_INTERVAL_MS = 1100;
const PAUSE_AFTER_CYCLE_MS = 1200;

const BRANCHES = [
    { id: "idea",      label: "Idea",      x: 200, y: 57,  rectX: 160, rectY: 36,  w: 80,  h: 42, fill: "#eaf6fc", stroke: "#229adb", textFill: "#155a85", path: "M200,150 L200,78", color: "#229adb" },
    { id: "concept",   label: "Concept",   x: 90,  y: 76,  rectX: 40,  rectY: 50,  w: 100, h: 42, fill: "#eaf6fc", stroke: "#229adb", textFill: "#155a85", path: "M200,150 Q140,90 90,92", color: "#229adb" },
    { id: "method",    label: "Method",    x: 310, y: 76,  rectX: 260, rectY: 50,  w: 100, h: 42, fill: "#eaf6fc", stroke: "#229adb", textFill: "#155a85", path: "M200,150 Q260,90 310,92", color: "#229adb" },
    { id: "technique", label: "Technique", x: 90,  y: 236, rectX: 40,  rectY: 210, w: 100, h: 42, fill: "#fff8e1", stroke: "#f1c84b", textFill: "#6a4b00", path: "M200,150 Q140,210 90,210", color: "#f1c84b" },
    { id: "pattern",   label: "Pattern",   x: 310, y: 236, rectX: 260, rectY: 210, w: 100, h: 42, fill: "#fff8e1", stroke: "#f1c84b", textFill: "#6a4b00", path: "M200,150 Q260,210 310,210", color: "#f1c84b" },
];

const MindMapsDemo = () => {
    const [revealed, setRevealed] = useState(0);
    const [highlight, setHighlight] = useState(-1);

    useEffect(() => {
        if (revealed < TOTAL_BRANCHES) {
            const timeout = setTimeout(() => {
                setRevealed((n) => n + 1);
            }, BRANCH_REVEAL_INTERVAL_MS);
            return () => clearTimeout(timeout);
        }

        if (highlight < TOTAL_BRANCHES - 1) {
            const timeout = setTimeout(() => {
                setHighlight((h) => h + 1);
            }, HIGHLIGHT_INTERVAL_MS);
            return () => clearTimeout(timeout);
        }

        const timeout = setTimeout(() => {
            setRevealed(0);
            setHighlight(-1);
        }, PAUSE_AFTER_CYCLE_MS);
        return () => clearTimeout(timeout);
    }, [revealed, highlight]);

    return (
        <div className="mindmaps-demo" aria-hidden="true">
            <div className="mm-header">
                <span className="mm-title">Mind Map</span>
                <span className="mm-pulse-dot" />
            </div>
            <div className="mm-body">
                <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="mm-svg">
                    {BRANCHES.map((b, i) => (
                        <path
                            key={b.id + "-path"}
                            d={b.path}
                            stroke={b.color}
                            strokeWidth="2.5"
                            fill="none"
                            strokeLinecap="round"
                            className={
                                "mm-branch-path" +
                                (i < revealed ? " is-visible" : "") +
                                (i === highlight ? " is-highlight" : "")
                            }
                        />
                    ))}

                    <g className="mm-root">
                        <rect x="155" y="125" width="90" height="52" rx="14" fill="#229adb" />
                        <text x="200" y="158" textAnchor="middle" fill="white" fontSize="16" fontWeight="700" fontFamily="Arial, sans-serif">Topic</text>
                    </g>

                    {BRANCHES.map((b, i) => (
                        <g
                            key={b.id + "-node"}
                            className={
                                "mm-branch-node" +
                                (i < revealed ? " is-visible" : "") +
                                (i === highlight ? " is-highlight" : "")
                            }
                            style={{ transformOrigin: b.x + "px " + b.y + "px" }}
                        >
                            <rect
                                x={b.rectX}
                                y={b.rectY}
                                width={b.w}
                                height={b.h}
                                rx="10"
                                fill={b.fill}
                                stroke={b.stroke}
                                strokeWidth="2"
                            />
                            <text
                                x={b.x}
                                y={b.y}
                                textAnchor="middle"
                                fill={b.textFill}
                                fontSize="13"
                                fontWeight="600"
                                fontFamily="Arial, sans-serif"
                            >
                                {b.label}
                            </text>
                        </g>
                    ))}
                </svg>
            </div>
        </div>
    );
};

export default MindMapsDemo;
